import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { destinationTreeAtom, flowIdsAtom } from './atoms'
import React from 'react'
import { OutlinedButton } from 'shared/ui'
import { FlowStatusGroup } from '../../contentService/FlowStatusGroup'

export function ReplaceJobsStatus() {
  const { resetTree } = useAtomValue(destinationTreeAtom)
  const flowIds = useAtomValue(flowIdsAtom)
  if (!flowIds.length) return null
  return (
    <FlowStatusGroup
      flowIds={flowIds}
      completedItems={[
        <OutlinedButton key="resetTree" onClick={resetTree}>
          Reset Tree
        </OutlinedButton>,
      ]}
    />
  )
}
